import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import "./reports.css"
import Select from 'react-select';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { PiDownloadSimple } from "react-icons/pi";
import moment from 'moment';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { BsFiletypeCsv } from "react-icons/bs";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import { BarLoader, ClipLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import { useCurrency } from '../../Layouts/currencyContext';
import { LiaFileExcel } from "react-icons/lia";
import * as XLSX from "xlsx";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

const MaterialReceive = () => {
    const apiService = new ApiService();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const { currencyprecision } = useCurrency();
    const [currencyPrecision, setPrecision] = useState(currencyprecision?.exp1 || 3);
    const [PoList, setPOlist] = useState();
    const [grnList, setGrnList] = useState();
    const [cost1, setCost1] = useState();
    const [cost2, setCost2] = useState();
    const [categoryList, setCategorylist] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [SupplierList, setSuppliers] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const gridRef = useRef();


    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const [formData, setFormData] = useState({
        costCenter1: [{ label: 'Select Property', value: '0' }],
        costCenter2: [{ label: 'Select Unit', value: '0' }],
        category: [{ label: 'Select Category', value: '' }],
        GrnNo: "",
        PONo: "",
        fromDate: '',          // Today's date
        toDate: '',
        itemNo: [{ label: 'Item No', value: '' }],
        ItemDescription: [{ label: 'Item Description', value: '' }],
        SupplierName: [{ label: 'Select Supplier', value: '' }],
    });
    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const params = new URLSearchParams();
                params.append('dropdownTypes', 'MRSuppliers,MRCostCenter1,MRCostCenter2,MRItemCatmast');
                const res = await apiService.getApiParamater('REPORTS_MULTI', `?${params.toString()}`);

                setCost1(res?.data?.dropdowns?.MRCostCenter1);
                setCost2(res?.data?.dropdowns?.MRCostCenter2);
                setSuppliers(res?.data?.dropdowns?.MRSuppliers);
                setCategorylist(res?.data?.dropdowns?.MRItemCatmast);

                const today = new Date();

                setFormData((prev) => ({
                    ...prev,
                    fromDate: formatDate(today),
                    toDate: formatDate(today),
                }));
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
        // getItems()
    }, []);
    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const handleClearFilters = () => {
        const today = new Date();

        setFormData({
            costCenter1: [{ label: 'Select Property', value: '0' }],
            costCenter2: [{ label: 'Select Unit', value: '0' }],
            category: [{ label: 'Select Category', value: '' }],
            GrnNo: "",
            PONo: "",
            itemNo: [{ label: 'Item No', value: '' }],
            ItemDescription: [{ label: 'Item Description', value: '' }],
            SupplierName: [{ label: 'Select Supplier', value: '' }],
            fromDate: formatDate(today),
            toDate: formatDate(today),
        });
    };
    const dateFormatter = (params) => {
        const date = moment.utc(params.value).local();
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const handleSearch = async () => {
        setSearchLoading(true);
        await getItems(1);
        setSearchLoading(false);
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true)
            setRowData([])

            const params = new URLSearchParams();
            params.append('CostCenter1', formData?.costCenter1?.label || "All");
            params.append('CostCenter2', formData?.costCenter2?.label || "All");
            params.append('POrderNo', formData?.PONo || "All");
            params.append('GRN', formData?.GrnNo || "All");
            params.append('Supplier', formData.SupplierName?.value?.value || "All");
            params.append('ItemCode', formData?.itemNo?.label || "All");
            params.append('ItemDesc', formData?.ItemDescription?.label || "All");
            params.append('Category', formData?.category?.value?.value || "All");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('FromDate', formData.fromDate);
            params.append('ToDate', formData.toDate);
            const res = await apiService.getApiParamater('GET_MATERIAL_RECEIVE', `?${params.toString()}`);
            setRowData(res?.data?.result || [])
            setPagination(res.data.paginationData);
            setLoading(false);
            setFormData((prev) => ({
                ...prev,
                fromDate: formData.fromDate,
                toDate: formData.toDate,
            }));
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'GrnReport.csv'
        });
    }, []);
    const handleItemChange = (selectedOption) => {
        setFormData({
            ...formData,
            itemNo: selectedOption ? { label: selectedOption.value.itemNo, value: selectedOption.value } : null,
            ItemDescription: selectedOption ? { label: selectedOption.value.itemDescription, value: selectedOption.value } : null,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const Comparison = [
        { headerName: 'Item Code', field: 'itemCode', suppressMovable: true, width: 140 },
        { headerName: 'Item Description', field: 'itemDescription', suppressMovable: true, width: 250 },
        { headerName: 'Category', field: 'catName', suppressMovable: true, width: 150 },
        { headerName: 'Stock Type', field: 'stockType', suppressMovable: true, width: 100, },
        {
            headerName: 'Trans Date', field: 'tranDate', suppressMovable: true, width: 140, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'UOM', field: 'uom', suppressMovable: true, width: 150 },
        { headerName: 'Qty', field: 'qty', suppressMovable: true, width: 150 },
        {
            headerName: 'Unit Price', field: 'unitPrice', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 4)
        },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 3)
        },
        { headerName: 'Vendor Name', field: 'vendorName', suppressMovable: true, width: 250 },
        { headerName: 'GRN NO', field: 'grnNo', suppressMovable: true, width: 150 },
        { headerName: 'POrder No', field: 'pOrderNo', suppressMovable: true, width: 150 },
        { headerName: 'Warehouse', field: 'warehouse', suppressMovable: true, width: 150 },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 150 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 150 }, {
            headerName: 'Status', field: 'grnStatus',
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                } else {
                    return params.value;
                }
            }, suppressMovable: true, width: 160
        }

    ];
    const onBtnExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            const params = new URLSearchParams();
            params.append('CostCenter1', formdata.costCenter1.label || "All");
            params.append('CostCenter2', formdata.costCenter2.label || "All");
            params.append('POrderNo', formdata.PONo || "All");
            params.append('GRN', formdata.GrnNo || "All");
            params.append('Supplier', formdata.SupplierName?.value?.value || "All");
            params.append('ItemCode', formdata.itemNo.label || "All");
            params.append('ItemDesc', formdata.ItemDescription.label || "All");
            params.append('Category', formdata?.category.value?.value || "All");
            params.append('PageNo', 1);
            params.append('PageSize', pagedata?.totalRecords || 10000);
            params.append('FromDate', formdata?.fromDate);
            params.append('ToDate', formdata?.toDate);

            const res = await apiService.getApiParamater('GET_MATERIAL_RECEIVE', `?${params.toString()}`);
            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                setLoading(false);
                return;
            }

            const totalAmount = allData.reduce((sum, item) => sum + (item.amount || 0), 0);


            const excelData = allData.map((item) => ({
                "Item No": item.itemCode,
                "Item Description": item.itemDescription,
                "Category Name": item.catName,
                "Stock Type": item.stockType,
                "Trans Date": moment(item.tranDate).format("DD-MMM-YY"),
                "UOM": item.uom,
                "QTY": Number(item.qty || 0).toFixed(currencyPrecision || 3),
                "Unit Price": Number(item.unitPrice || 0).toFixed(currencyPrecision || 3),
                "Amount": Number(item.amount || 0).toFixed(currencyPrecision || 3),
                "Vendor Name": item.vendorName,
                "GRN NO": item.grnNo,
                "POrderNo": item.pOrderNo,
                "warehouse": item.warehouse,
                "Status": item.grnStatus === 1 ? "Approved" : item.grnStatus === 0 ? "Pending" : item.grnStatus === 5 ? "Hold" : "Rejected",
                "Property": item.costCenter1,
                "Unit": item.costCenter2,
            }));

            excelData.push({}); // Add an empty row for spacing

            const totalRow = {
                "Item No": "",
                "Item Description": "",
                "Category Name": "",
                "Stock Type": "",
                "Trans Date": "",
                "UOM": "",
                "QTY": "",
                "Unit Price": "Total",
                "Amount": Number(totalAmount || 0).toFixed(currencyPrecision || 3),
                "Vendor Name": "",
                "GRN NO": "",
                "POrderNo": "",
                "warehouse": "",
                "Status": "",
                "Property": "",
                "Unit": "",
            };
            excelData.push(totalRow);

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            // Auto-fit column widths
            const columnWidths = Object.keys(excelData[0]).map((header) => {
                if (header === "itemDescription") {
                    return { wch: 60 };
                }
                const maxLength = Math.max(
                    header.length,
                    ...excelData.map((row) =>
                        row[header] ? row[header].toString().length : 0
                    )
                );

                return { wch: maxLength };
            });
            // Style for the total row
            const totalRowStyle = {
                font: { bold: true },
                fill: { fgColor: { rgb: "E0E0E0" } } // Light Grey
            };

            // Get the range of the worksheet
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            const totalRowIndex = excelData.length; // 0-indexed row in the sheet data (excluding header)

            // Apply style to each cell in the total row
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: C });
                if (worksheet[cellAddress]) worksheet[cellAddress].s = totalRowStyle;
            }

            worksheet["!cols"] = columnWidths;

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Material Received Report");

            XLSX.writeFile(workbook, "Material_Received_Report.xlsx");

            toast.success("Material_Received_Report.xlsx downloaded");
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    }, [currencyPrecision]);

    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }

    const handleShow = () => {
        {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: 'MaterialReceived' },
                    { name: 'FromDate', value: formData?.fromDate },
                    { name: 'toDate', value: formData?.toDate },
                    { name: 'GRNNo', value: formData?.GrnNo || '' },
                    { name: 'PoNo', value: formData?.PONo || '' },
                    { name: 'ItemNo', value: formData?.itemNo?.label || '' },
                    { name: 'ItemName', value: formData?.ItemDescription?.label || '' },
                    { name: 'Category', value: formData?.category?.value?.value || '' },
                    { name: 'VendorNo', value: formData?.SupplierName?.value?.value || '' },
                    { name: 'VendorName', value: formData?.SupplierName?.value?.value || '' },
                    { name: 'CostCenter1', value: formData?.costCenter1?.label || '' },
                    { name: 'CostCenter2', value: formData?.costCenter2?.label || '' },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    };
    return (
        <div className='p-4'>
            <div className='gridBg m-0' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row' >
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            isClearable
                            value={formData.SupplierName}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'SupplierName', value: selectedOption })}
                            options={SupplierList?.map((supl) => ({ value: supl, label: supl?.text }))}
                        />
                    </div>
                    <div className='col'>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.GrnNo}
                            name="GrnNo"
                            placeholder='Enter GRN No'
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col'>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.PONo}
                            name="PONo"
                            placeholder='Enter POrder No'
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className='row my-2'>
                    <div className="d-flex justify-content-between start col-md-4 col-lg-4">
                        <label htmlFor="validationCustom02" className="form-label  pt-1 start">From Date</label>
                        <DatePicker
                            selected={formData.fromDate}
                            onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                            className="p-2 form-Input w-100"
                            dateFormat="dd-MM-yyyy"
                        />
                    </div>
                    <div className="d-flex justify-content-between start col-md-4">
                        <label htmlFor="validationCustom02" className="form-label  pt-1 start">To Date</label>
                        <DatePicker
                            selected={formData.toDate}
                            onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                            className="p-2 form-Input w-100"
                            dateFormat="dd-MM-yyyy"
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            isClearable
                            value={formData.costCenter1}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter1', value: selectedOption })}
                            options={cost1?.map((rec) => ({ value: rec, label: `${rec?.text}` }))}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <AsyncSelect
                            cacheOptions
                            value={formData.itemNo}
                            options={itemOptions}
                            isClearable
                            loadOptions={loadOptions}
                            onChange={selectedOption => handleItemChange(selectedOption)}
                            defaultOptions={itemOptions}
                            onMenuScrollToBottom={loadMoreOptions}
                            noOptionsMessage={({ inputValue }) =>
                                inputValue.length < 3
                                    ? "Type at least 3 characters..."
                                    : "No records found"
                            }
                        />
                    </div>
                    <div className='col'>

                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            isClearable
                            value={formData.category}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
                            options={categoryList?.map((Stock) => ({ value: Stock, label: Stock?.text }))}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            isClearable
                            value={formData.costCenter2}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter2', value: selectedOption })}
                            options={cost2?.map((rec) => ({ value: rec, label: `${rec?.text}` }))}
                        />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col'>
                        <AsyncSelect
                            cacheOptions
                            value={formData.ItemDescription}
                            options={descriptionOptions}
                            isClearable
                            loadOptions={loadDescOptions}
                            onChange={selectedOption => handleItemChange(selectedOption)}
                            className="w-100 p-0"
                            defaultOptions={descriptionOptions}
                            onMenuScrollToBottom={loadMoreDescOptions}
                            noOptionsMessage={({ inputValue }) =>
                                inputValue.length < 3
                                    ? "Type at least 3 characters..."
                                    : "No records found"
                            }
                        />
                    </div>
                    <div className='col'>
                        <div onClick={() => handleSearch()} className='mainbtnGry flex-end gap-2'>
                            {searchLoading ? (
                                <ClipLoader color='#fff' size={16} className='center mt-1 mx-2' />
                            ) : (
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                            )}
                            <div className='center'>Search</div>
                        </div>
                    </div>
                    <div className='col'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Material Received Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnExcelExport(formData, pagination)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className='mainbtn flex-end gap-1' onClick={handleShow}>
                        <div className='center'>Show</div>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            columnDefs={Comparison}
                            ref={gridRef}
                            loading={loading}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};
export default MaterialReceive;